"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports["default"] = exports.ACTION = void 0;

var _error = require("./error");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACTION = {
  LOAD: 'loader-load'
};
/**
 * @module actions/loader
 *
 * Loader actions execute a promise
 * with loading state at start and end. Provide
 * a unique key for the loading state
 */

exports.ACTION = ACTION;
var _default = {
  /**
   * Execute a nested load operation. Will set the appropriate key and
   * invoke the callback promise
   *
   * @param {string} key - The load key
   * @param {Promise} cb - The promise
   *
   * @return {Promise}
   */
  load: function load(key, cb) {
    var errorHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return function (dispatch, getState) {
      dispatch(_defineProperty({
        type: ACTION.LOAD
      }, key, true));
      return cb(dispatch, getState)["catch"](function (err) {
        return dispatch((0, _error.exception)(err, errorHandler));
      }).then(function (res) {
        dispatch(_defineProperty({
          type: ACTION.LOAD
        }, key, false));
        return res;
      });
    };
  }
};
/**
 * @type {object}
 */

exports["default"] = _default;
var initial = {};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var type = action.type,
      payload = _objectWithoutProperties(action, ["type"]);

  switch (type) {
    case ACTION.LOAD:
      return _objectSpread(_objectSpread({}, state), payload);

    default:
      return state;
  }
};

exports.reducer = reducer;